import { types } from "../actions/authActions";

const authStore = {
  isLoggedIn: false,
};

export default function authReducer(state = authStore, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
      };
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return { ...state };
  }
}
